module.exports = __webpack_public_path__ + "static/Bibox-375e9cba03e50d4e6c841b48b37fb1fb.png";